// This file is auto-generated by @hey-api/openapi-ts
import { infiniteQueryOptions, queryOptions, } from "@tanstack/react-query";
import { client } from "../client.gen";
import { deleteCountriesByCountryCode, deleteMunicipalitiesByMunicipalityId, deleteMunicipalitiesByMunicipalityIdGeoFence, deleteMunicipalitiesByMunicipalityIdPointOfInterestCorrectionsByCorrectionId, deleteMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrectionsByCorrectionId, deleteMunicipalitiesByMunicipalityIdRolesByRoleId, deleteRolesByRoleId, getCountries, getCountriesByCountryCode, getCountriesByCountryCodeDataSources, getFeatureFlags, getInvites, getMunicipalities, getMunicipalitiesByMunicipalityId, getMunicipalitiesByMunicipalityIdBuildings, getMunicipalitiesByMunicipalityIdBuildingsJobsByJobIdEvents, getMunicipalitiesByMunicipalityIdBuildingsJobsLatest, getMunicipalitiesByMunicipalityIdDataSources, getMunicipalitiesByMunicipalityIdGeoFence, getMunicipalitiesByMunicipalityIdInvites, getMunicipalitiesByMunicipalityIdLandUseZones, getMunicipalitiesByMunicipalityIdLandUseZonesJobsByJobIdEvents, getMunicipalitiesByMunicipalityIdLandUseZonesJobsLatest, getMunicipalitiesByMunicipalityIdPermissionPackages, getMunicipalitiesByMunicipalityIdPermissions, getMunicipalitiesByMunicipalityIdPointOfInterestCorrections, getMunicipalitiesByMunicipalityIdPointsOfInterest, getMunicipalitiesByMunicipalityIdPointsOfInterestJobsByJobIdEvents, getMunicipalitiesByMunicipalityIdPointsOfInterestJobsLatest, getMunicipalitiesByMunicipalityIdPopulationCells, getMunicipalitiesByMunicipalityIdPopulationJobsByJobIdEvents, getMunicipalitiesByMunicipalityIdPopulationJobsLatest, getMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrections, getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsByJobIdEvents, getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsLatest, getMunicipalitiesByMunicipalityIdRoadSegments, getMunicipalitiesByMunicipalityIdRoadSegmentsJobsByJobIdEvents, getMunicipalitiesByMunicipalityIdRoadSegmentsJobsLatest, getMunicipalitiesByMunicipalityIdRoadSegmentsSummary, getMunicipalitiesByMunicipalityIdRoles, getMunicipalitiesByMunicipalityIdRolesByRoleId, getMunicipalitiesByMunicipalityIdUsers, getPermissionPackages, getPermissions, getRoles, getRolesByRoleId, getUsers, getUsersMe, patchMunicipalitiesByMunicipalityId, patchMunicipalitiesByMunicipalityIdRolesByRoleId, patchMunicipalitiesByMunicipalityIdUsersByUserId, patchRolesByRoleId, patchUsersByUserId, patchUsersMeSettings, postAuthLogin, postAuthLogout, postAuthPassword, postCountries, postInvites, postInvitesByInviteIdResend, postInvitesByInviteIdRevoke, postMunicipalities, postMunicipalitiesByMunicipalityIdBuildingsJobs, postMunicipalitiesByMunicipalityIdBuildingsJobsByJobIdCancel, postMunicipalitiesByMunicipalityIdInvites, postMunicipalitiesByMunicipalityIdInvitesByInviteIdResend, postMunicipalitiesByMunicipalityIdInvitesByInviteIdRevoke, postMunicipalitiesByMunicipalityIdLandUseZonesJobs, postMunicipalitiesByMunicipalityIdLandUseZonesJobsByJobIdCancel, postMunicipalitiesByMunicipalityIdPointOfInterestCorrections, postMunicipalitiesByMunicipalityIdPointsOfInterestJobs, postMunicipalitiesByMunicipalityIdPointsOfInterestJobsByJobIdCancel, postMunicipalitiesByMunicipalityIdPopulationJobs, postMunicipalitiesByMunicipalityIdPopulationJobsByJobIdCancel, postMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrections, postMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobs, postMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsByJobIdCancel, postMunicipalitiesByMunicipalityIdRoadSegmentsJobs, postMunicipalitiesByMunicipalityIdRoadSegmentsJobsByJobIdCancel, postMunicipalitiesByMunicipalityIdRoles, postRoles, putCountriesByCountryCode, putCountriesByCountryCodeDataSourcesByKind, putFeatureFlagsByFlag, putMunicipalitiesByMunicipalityIdDataSourcesByKind, putMunicipalitiesByMunicipalityIdGeoFence, putMunicipalitiesByMunicipalityIdPermissionPackages, putMunicipalitiesByMunicipalityIdPermissions, } from "../sdk.gen";
const createQueryKey = (id, options, infinite, tags) => {
    const params = {
        _id: id,
        baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
    };
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};
export const getMunicipalitiesQueryKey = (options) => createQueryKey("getMunicipalities", options);
/**
 * Get municipalities
 *
 * **Allowed Permissions:** `municipalities:read:global`
 */
export const getMunicipalitiesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesQueryKey(options),
});
const createInfiniteParams = (queryKey, page) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body,
            ...page.body,
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers,
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path,
            ...page.path,
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query,
            ...page.query,
        };
    }
    return params;
};
export const getMunicipalitiesInfiniteQueryKey = (options) => createQueryKey("getMunicipalities", options, true);
/**
 * Get municipalities
 *
 * **Allowed Permissions:** `municipalities:read:global`
 */
export const getMunicipalitiesInfiniteOptions = (options) => {
    const opts = infiniteQueryOptions(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMunicipalities({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getMunicipalitiesInfiniteQueryKey(options),
    });
    return opts;
};
/**
 * Create municipality. `dataSources` lists the adapters to switch on beyond the built-in ones (category defaults, OpenStreetMap, manual corrections), each as a (source, kind) pair with a rank; rank 1 is consulted first among them.
 *
 * **Allowed Permissions:** `municipalities:create:global`
 */
export const postMunicipalitiesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalities({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete municipality
 *
 * **Allowed Permissions:** `municipalities:delete:global`
 */
export const deleteMunicipalitiesByMunicipalityIdMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMunicipalitiesByMunicipalityId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityId", options);
/**
 * Get municipality
 *
 * **Allowed Permissions:** `municipalities:read:global`
 */
export const getMunicipalitiesByMunicipalityIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdQueryKey(options),
});
/**
 * Rename a municipality or move it to another configured country. Only the fields given change; the country's settings apply from its next import.
 *
 * **Allowed Permissions:** `municipalities:update:global`
 */
export const patchMunicipalitiesByMunicipalityIdMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchMunicipalitiesByMunicipalityId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdDataSourcesQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdDataSources", options);
/**
 * Get the adapters a municipality has switched on, by kind and rank. The built-in adapters are not listed because they cannot be switched off.
 *
 * **Allowed Permissions:** `municipalities:read:global`
 */
export const getMunicipalitiesByMunicipalityIdDataSourcesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdDataSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdDataSourcesQueryKey(options),
});
/**
 * Replace the adapters a municipality has switched on for one kind of data. The list is complete for that kind: an adapter of it not in the list is switched off. Adapters of the other kinds are left alone. Every row must name the kind in the path. Takes effect on the next import of that kind.
 *
 * **Allowed Permissions:** `municipalities:update:global`
 */
export const putMunicipalitiesByMunicipalityIdDataSourcesByKindMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await putMunicipalitiesByMunicipalityIdDataSourcesByKind({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete geo fence
 *
 * **Allowed Permissions:** `geo-fences:delete:global`
 */
export const deleteMunicipalitiesByMunicipalityIdGeoFenceMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMunicipalitiesByMunicipalityIdGeoFence({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdGeoFenceQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdGeoFence", options);
/**
 * Get geo fence
 *
 * **Allowed Permissions:** `geo-fences:read:global`
 */
export const getMunicipalitiesByMunicipalityIdGeoFenceOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdGeoFence({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdGeoFenceQueryKey(options),
});
/**
 * Create or replace geo fence
 *
 * **Allowed Permissions:** `geo-fences:create:global`, `geo-fences:update:global`
 */
export const putMunicipalitiesByMunicipalityIdGeoFenceMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await putMunicipalitiesByMunicipalityIdGeoFence({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdPointOfInterestCorrectionsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdPointOfInterestCorrections", options);
/**
 * List the corrections an operator has made to the places on the municipality geo fence: places added by hand, and feed places taken out of use. Responds 404 without a fence.
 *
 * **Allowed Permissions:** `points-of-interest:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPointOfInterestCorrectionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdPointOfInterestCorrections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdPointOfInterestCorrectionsQueryKey(options),
});
/**
 * Store a correction. An add carries a point inside the geo fence and the category it belongs to; a suppress names a feed and that feed’s own id for the place to take out. Either takes effect on the next read of the places endpoint, without an import. Responds 400 for a point outside the fence and 409 if the same place is already suppressed.
 *
 * **Allowed Permissions:** `points-of-interest:import:global`
 */
export const postMunicipalitiesByMunicipalityIdPointOfInterestCorrectionsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdPointOfInterestCorrections({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a correction: removing an add takes the hand-placed place off the map, and removing a suppress puts the feed’s place back. Both take effect immediately.
 *
 * **Allowed Permissions:** `points-of-interest:import:global`
 */
export const deleteMunicipalitiesByMunicipalityIdPointOfInterestCorrectionsByCorrectionIdMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMunicipalitiesByMunicipalityIdPointOfInterestCorrectionsByCorrectionId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Queue a points of interest import for the municipality geo fence: fetches the places the enabled feed knows of around the fence, keeps the ones inside it and replaces what that feed stored before. Responds 409 while any import for the same fence is queued or running, and 409 when the municipality has no places feed enabled.
 *
 * **Allowed Permissions:** `points-of-interest:import:global`
 */
export const postMunicipalitiesByMunicipalityIdPointsOfInterestJobsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdPointsOfInterestJobs({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdPointsOfInterestJobsLatestQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdPointsOfInterestJobsLatest", options);
/**
 * Get the most recent places import with its steps and the feed it was planned with. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `points-of-interest:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPointsOfInterestJobsLatestOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdPointsOfInterestJobsLatest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdPointsOfInterestJobsLatestQueryKey(options),
});
/**
 * Ask a queued or running places import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `points-of-interest:import:global`
 */
export const postMunicipalitiesByMunicipalityIdPointsOfInterestJobsByJobIdCancelMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdPointsOfInterestJobsByJobIdCancel({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdPointsOfInterestJobsByJobIdEventsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdPointsOfInterestJobsByJobIdEvents", options);
/**
 * Get places import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `points-of-interest:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPointsOfInterestJobsByJobIdEventsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdPointsOfInterestJobsByJobIdEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdPointsOfInterestJobsByJobIdEventsQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdPointsOfInterestQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdPointsOfInterest", options);
/**
 * Get the places in use inside the municipality geo fence: the enabled feed’s rows, each flagged with whether a correction has taken it out of use, plus the places added by hand. Unpaginated by design: this is what the map layer draws, and a partly drawn map is worse than none. An empty list is the honest answer for a municipality with no feed enabled.
 *
 * **Allowed Permissions:** `points-of-interest:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPointsOfInterestOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdPointsOfInterest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdPointsOfInterestQueryKey(options),
});
/**
 * Queue a population import for the municipality geo fence: fetches the residence grid the enabled feed publishes around the fence, works out how much of each cell lies inside it and replaces what that feed stored before. Responds 409 while any import for the same fence is queued or running, and 409 when the municipality has no population feed enabled.
 *
 * **Allowed Permissions:** `population:import:global`
 */
export const postMunicipalitiesByMunicipalityIdPopulationJobsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdPopulationJobs({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdPopulationJobsLatestQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdPopulationJobsLatest", options);
/**
 * Get the most recent population import with its steps and the feed it was planned with. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `population:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPopulationJobsLatestOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdPopulationJobsLatest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdPopulationJobsLatestQueryKey(options),
});
/**
 * Ask a queued or running population import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `population:import:global`
 */
export const postMunicipalitiesByMunicipalityIdPopulationJobsByJobIdCancelMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdPopulationJobsByJobIdCancel({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdPopulationJobsByJobIdEventsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdPopulationJobsByJobIdEvents", options);
/**
 * Get population import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `population:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPopulationJobsByJobIdEventsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdPopulationJobsByJobIdEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdPopulationJobsByJobIdEventsQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdPopulationCellsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdPopulationCells", options);
/**
 * Get the population grid cells stored for the municipality geo fence, the ones around it included: a catchment that crosses the boundary needs its neighbours, and `overlapFraction` tells the two apart — 0 marks a context cell outside the fence. Unpaginated by design: this is what the heat map draws and what the models weight, and a partly drawn grid is worse than none. An empty list is the honest answer for a municipality with no feed enabled.
 *
 * **Allowed Permissions:** `population:read:global`
 */
export const getMunicipalitiesByMunicipalityIdPopulationCellsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdPopulationCells({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdPopulationCellsQueryKey(options),
});
/**
 * Queue a land use import for the municipality geo fence: fetches the areas the enabled feed has mapped around the fence, clips them to it, settles where they overlap and replaces what that feed stored before. Responds 409 while any import for the same fence is queued or running, and 409 when the municipality has no land use feed enabled.
 *
 * **Allowed Permissions:** `land-use-zones:import:global`
 */
export const postMunicipalitiesByMunicipalityIdLandUseZonesJobsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdLandUseZonesJobs({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdLandUseZonesJobsLatestQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdLandUseZonesJobsLatest", options);
/**
 * Get the most recent land use import with its steps and the feed it was planned with. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `land-use-zones:read:global`
 */
export const getMunicipalitiesByMunicipalityIdLandUseZonesJobsLatestOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdLandUseZonesJobsLatest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdLandUseZonesJobsLatestQueryKey(options),
});
/**
 * Ask a queued or running land use import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `land-use-zones:import:global`
 */
export const postMunicipalitiesByMunicipalityIdLandUseZonesJobsByJobIdCancelMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdLandUseZonesJobsByJobIdCancel({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdLandUseZonesJobsByJobIdEventsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdLandUseZonesJobsByJobIdEvents", options);
/**
 * Get land use import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `land-use-zones:read:global`
 */
export const getMunicipalitiesByMunicipalityIdLandUseZonesJobsByJobIdEventsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdLandUseZonesJobsByJobIdEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdLandUseZonesJobsByJobIdEventsQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdLandUseZonesQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdLandUseZones", options);
/**
 * Get the land use zones stored for the municipality geo fence, clipped to it. One feed’s zones do not overlap, so their areas add up to the ground they cover. Unpaginated by design: this is what the map draws and what the models read, and a partly drawn map reads as land with no use. An empty list is the honest answer for a municipality with no feed enabled.
 *
 * **Allowed Permissions:** `land-use-zones:read:global`
 */
export const getMunicipalitiesByMunicipalityIdLandUseZonesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdLandUseZones({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdLandUseZonesQueryKey(options),
});
/**
 * Queue a buildings import for the municipality geo fence: reads the footprints the enabled base publishes around the fence, keeps each building whole, fills what the source leaves out from per-use defaults and shares each population cell over the buildings in it. Responds 409 while any import for the same fence is queued or running, and 409 when the municipality has no buildings feed enabled.
 *
 * **Allowed Permissions:** `buildings:import:global`
 */
export const postMunicipalitiesByMunicipalityIdBuildingsJobsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdBuildingsJobs({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdBuildingsJobsLatestQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdBuildingsJobsLatest", options);
/**
 * Get the most recent buildings import with its steps, the base it was planned with and, once it has finished, its quality report. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `buildings:read:global`
 */
export const getMunicipalitiesByMunicipalityIdBuildingsJobsLatestOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdBuildingsJobsLatest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdBuildingsJobsLatestQueryKey(options),
});
/**
 * Ask a queued or running buildings import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `buildings:import:global`
 */
export const postMunicipalitiesByMunicipalityIdBuildingsJobsByJobIdCancelMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdBuildingsJobsByJobIdCancel({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdBuildingsJobsByJobIdEventsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdBuildingsJobsByJobIdEvents", options);
/**
 * Get buildings import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `buildings:read:global`
 */
export const getMunicipalitiesByMunicipalityIdBuildingsJobsByJobIdEventsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdBuildingsJobsByJobIdEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdBuildingsJobsByJobIdEventsQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdBuildingsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdBuildings", options);
/**
 * Get the buildings the enabled base stored for the municipality geo fence, one row per building with its whole MultiPolygon footprint, its resolved values, where each came from, and its residents. Buildings around the fence come too, so a population cell on the edge reads whole; `inFence` tells them apart, and only the fence’s own carry residents. `residentsEstimate` is null when the population was re-imported after the estimate: re-import the buildings to refresh it. Every use and stage is stored; pass `uses` and `stages` to narrow, such as `stages=existing`. Unpaginated by design, like the population grid: the map and the models read the fence whole. An empty list is the honest answer for a municipality with no buildings feed enabled.
 *
 * **Allowed Permissions:** `buildings:read:global`
 */
export const getMunicipalitiesByMunicipalityIdBuildingsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdBuildings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdBuildingsQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrectionsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrections", options);
/**
 * List the manual corrections drawn inside the municipality geo fence: lines an operator placed over a stretch of road with the attribute values they assert for it. Responds 404 without a fence.
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrectionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrectionsQueryKey(options),
});
/**
 * Store a manual correction: a line along a stretch of road and at least one attribute value for it. A name needs a name kind. The correction is applied by the manual adapter on the next attributes import, where it wins over every other source for the segments the line covers.
 *
 * **Allowed Permissions:** `road-segment-attributes:import:global`
 */
export const postMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrectionsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrections({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a correction. Observations it produced stay until the next attributes import re-runs the manual adapter.
 *
 * **Allowed Permissions:** `road-segment-attributes:import:global`
 */
export const deleteMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrectionsByCorrectionIdMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMunicipalitiesByMunicipalityIdRoadSegmentAttributeCorrectionsByCorrectionId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Queue a road segment attributes import for the municipality geo fence. Runs every attribute adapter in the municipality’s run order (category defaults, OpenStreetMap, the configured adapters by rank, manual corrections), then resolves one value per attribute and names the intersections. Requires a road network; run the road segments import first. Responds 409 while any import for the same fence is queued or running.
 *
 * **Allowed Permissions:** `road-segment-attributes:import:global`
 */
export const postMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobs({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsLatestQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsLatest", options);
/**
 * Get the most recent attributes import with its steps and the adapter run order it was planned with. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsLatestOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsLatest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsLatestQueryKey(options),
});
/**
 * Ask a queued or running attributes import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `road-segment-attributes:import:global`
 */
export const postMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsByJobIdCancelMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsByJobIdCancel({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsByJobIdEventsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsByJobIdEvents", options);
/**
 * Get attributes import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsByJobIdEventsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsByJobIdEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdRoadSegmentAttributesJobsByJobIdEventsQueryKey(options),
});
/**
 * Queue a road segments (topology) import for the municipality geo fence: fetches OpenStreetMap, builds the segments and intersections and links them. Replaces the network, which also clears every attribute observation on it; run the attributes import afterwards. Responds 409 while any import for the same fence is queued or running.
 *
 * **Allowed Permissions:** `road-segments:import:global`
 */
export const postMunicipalitiesByMunicipalityIdRoadSegmentsJobsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdRoadSegmentsJobs({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdRoadSegmentsJobsLatestQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdRoadSegmentsJobsLatest", options);
/**
 * Get the most recent road segments import with its steps. Responds 404 if none has ever run.
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentsJobsLatestOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdRoadSegmentsJobsLatest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdRoadSegmentsJobsLatestQueryKey(options),
});
/**
 * Ask a queued or running import to stop. A running import stops at its next stage boundary. Responds 409 if the import has already finished.
 *
 * **Allowed Permissions:** `road-segments:import:global`
 */
export const postMunicipalitiesByMunicipalityIdRoadSegmentsJobsByJobIdCancelMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdRoadSegmentsJobsByJobIdCancel({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdRoadSegmentsJobsByJobIdEventsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdRoadSegmentsJobsByJobIdEvents", options);
/**
 * Get import log events newer than a cursor, oldest first
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentsJobsByJobIdEventsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdRoadSegmentsJobsByJobIdEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdRoadSegmentsJobsByJobIdEventsQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdRoadSegmentsSummaryQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdRoadSegmentsSummary", options);
/**
 * Get road segment and junction counts for the stored network
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentsSummaryOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdRoadSegmentsSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdRoadSegmentsSummaryQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdRoadSegmentsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdRoadSegments", options);
/**
 * Get every road segment and junction of the stored network. Unpaginated by design: a partly drawn map is worse than none, and this is what the map layer consumes. Pass excludeCategories=service to leave out minor access roads — back lanes, courtyard and delivery entrances, driveways, parking aisles. Their share swings with how suburban the area is, from 38% of length in a town of detached houses to under 8% in a dense city centre; junctions left with no segment are dropped with them.
 *
 * **Allowed Permissions:** `road-segments:read:global`
 */
export const getMunicipalitiesByMunicipalityIdRoadSegmentsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdRoadSegments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdRoadSegmentsQueryKey(options),
});
export const getUsersMeQueryKey = (options) => createQueryKey("getUsersMe", options);
/**
 * Get current user information
 */
export const getUsersMeOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUsersMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getUsersMeQueryKey(options),
});
export const getUsersQueryKey = (options) => createQueryKey("getUsers", options);
/**
 * List every user, global and municipality ones, with their role. Paged, sorted and filtered by the query; `email[ilike]=…` searches by email.
 *
 * **Allowed Permissions:** `users:read:global`
 */
export const getUsersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getUsersQueryKey(options),
});
export const getUsersInfiniteQueryKey = (options) => createQueryKey("getUsers", options, true);
/**
 * List every user, global and municipality ones, with their role. Paged, sorted and filtered by the query; `email[ilike]=…` searches by email.
 *
 * **Allowed Permissions:** `users:read:global`
 */
export const getUsersInfiniteOptions = (options) => {
    const opts = infiniteQueryOptions(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getUsersInfiniteQueryKey(options),
    });
    return opts;
};
/**
 * Change a user's role, to one whose permissions you hold yourself, or deactivate them. A deactivated user can't sign in, and their sessions stop working. You cannot change your own user.
 *
 * **Allowed Permissions:** `users:update:global`
 */
export const patchUsersByUserIdMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchUsersByUserId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Log in with email and password; the session is set in cookies
 */
export const postAuthLoginMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAuthLogin({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Log out and revoke the current session
 */
export const postAuthLogoutMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAuthLogout({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Set a password with the token from an invite email; signs out other sessions
 */
export const postAuthPasswordMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAuthPassword({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getPermissionsQueryKey = (options) => createQueryKey("getPermissions", options);
/**
 * List the permission catalogue, paged, sorted and filtered (by `scope`, or `action`).
 *
 * **Allowed Permissions:** `permissions:read:global`
 */
export const getPermissionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPermissionsQueryKey(options),
});
export const getPermissionsInfiniteQueryKey = (options) => createQueryKey("getPermissions", options, true);
/**
 * List the permission catalogue, paged, sorted and filtered (by `scope`, or `action`).
 *
 * **Allowed Permissions:** `permissions:read:global`
 */
export const getPermissionsInfiniteOptions = (options) => {
    const opts = infiniteQueryOptions(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getPermissions({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getPermissionsInfiniteQueryKey(options),
    });
    return opts;
};
export const getMunicipalitiesByMunicipalityIdPermissionsQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdPermissions", options);
/**
 * List the permissions a municipality may use: the ceiling for its roles. Its own users can read it to build roles from.
 *
 * **Allowed Permissions:** `permissions:read:global`, `permissions:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdPermissionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdPermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdPermissionsQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdPermissionsInfiniteQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdPermissions", options, true);
/**
 * List the permissions a municipality may use: the ceiling for its roles. Its own users can read it to build roles from.
 *
 * **Allowed Permissions:** `permissions:read:global`, `permissions:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdPermissionsInfiniteOptions = (options) => {
    const opts = infiniteQueryOptions(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMunicipalitiesByMunicipalityIdPermissions({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getMunicipalitiesByMunicipalityIdPermissionsInfiniteQueryKey(options),
    });
    return opts;
};
/**
 * Replace the permissions a municipality may use. Only municipality permissions are accepted. A permission left out is also taken off every role in the municipality.
 *
 * **Allowed Permissions:** `permissions:update:global`
 */
export const putMunicipalitiesByMunicipalityIdPermissionsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await putMunicipalitiesByMunicipalityIdPermissions({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getFeatureFlagsQueryKey = (options) => createQueryKey("getFeatureFlags", options);
/**
 * List every feature flag defined in code with its stage, the permissions it brings, and who it is on for in this environment.
 *
 * **Allowed Permissions:** `feature-flags:read:global`
 */
export const getFeatureFlagsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFeatureFlags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getFeatureFlagsQueryKey(options),
});
/**
 * Set who a feature flag is on for: off, the given municipalities, or everyone. The municipalities are kept whatever the rollout. Municipalities that lose the flag lose its permissions from their roles.
 *
 * **Allowed Permissions:** `feature-flags:update:global`
 */
export const putFeatureFlagsByFlagMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await putFeatureFlagsByFlag({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getPermissionPackagesQueryKey = (options) => createQueryKey("getPermissionPackages", options);
/**
 * List every permission package defined in code, with the municipality permissions it brings.
 *
 * **Allowed Permissions:** `permissions:read:global`
 */
export const getPermissionPackagesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPermissionPackages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getPermissionPackagesQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdPermissionPackagesQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdPermissionPackages", options);
/**
 * List the permission packages a municipality has. Its own users can read them, as part of what its roles may be built from.
 *
 * **Allowed Permissions:** `permissions:read:global`, `permissions:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdPermissionPackagesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdPermissionPackages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdPermissionPackagesQueryKey(options),
});
/**
 * Replace the permission packages a municipality has. A package left out also takes its permissions off the municipality’s roles, unless they have them another way.
 *
 * **Allowed Permissions:** `permissions:update:global`
 */
export const putMunicipalitiesByMunicipalityIdPermissionPackagesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await putMunicipalitiesByMunicipalityIdPermissionPackages({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getRolesQueryKey = (options) => createQueryKey("getRoles", options);
/**
 * List the global roles with their permissions, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `roles:read:global`
 */
export const getRolesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRoles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getRolesQueryKey(options),
});
export const getRolesInfiniteQueryKey = (options) => createQueryKey("getRoles", options, true);
/**
 * List the global roles with their permissions, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `roles:read:global`
 */
export const getRolesInfiniteOptions = (options) => {
    const opts = infiniteQueryOptions(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getRoles({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getRolesInfiniteQueryKey(options),
    });
    return opts;
};
/**
 * Create a global role. It may only hold global permissions; giving it any needs `permissions:grant:global`, and only permissions you hold yourself.
 *
 * **Allowed Permissions:** `roles:create:global`
 */
export const postRolesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postRoles({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a global role that no user holds. The Admin role cannot be deleted.
 *
 * **Allowed Permissions:** `roles:delete:global`
 */
export const deleteRolesByRoleIdMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteRolesByRoleId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getRolesByRoleIdQueryKey = (options) => createQueryKey("getRolesByRoleId", options);
/**
 * Get a global role with its permissions.
 *
 * **Allowed Permissions:** `roles:read:global`
 */
export const getRolesByRoleIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRolesByRoleId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getRolesByRoleIdQueryKey(options),
});
/**
 * Rename a global role or replace its permissions (which needs `permissions:grant:global`). The Admin role is managed by the seed and cannot be changed here.
 *
 * **Allowed Permissions:** `roles:update:global`
 */
export const patchRolesByRoleIdMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchRolesByRoleId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdRolesQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdRoles", options);
/**
 * List a municipality's roles with their permissions, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `roles:read:global`, `roles:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdRolesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdRoles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdRolesQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdRolesInfiniteQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdRoles", options, true);
/**
 * List a municipality's roles with their permissions, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `roles:read:global`, `roles:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdRolesInfiniteOptions = (options) => {
    const opts = infiniteQueryOptions(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMunicipalitiesByMunicipalityIdRoles({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getMunicipalitiesByMunicipalityIdRolesInfiniteQueryKey(options),
    });
    return opts;
};
/**
 * Create a role in a municipality. It may only hold permissions from the municipality's available set; giving it any needs `permissions:grant`, and only permissions you hold.
 *
 * **Allowed Permissions:** `roles:create:global`, `roles:create:municipality`
 */
export const postMunicipalitiesByMunicipalityIdRolesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdRoles({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a municipality's role that no user holds.
 *
 * **Allowed Permissions:** `roles:delete:global`, `roles:delete:municipality`
 */
export const deleteMunicipalitiesByMunicipalityIdRolesByRoleIdMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMunicipalitiesByMunicipalityIdRolesByRoleId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdRolesByRoleIdQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdRolesByRoleId", options);
/**
 * Get one of a municipality's roles with its permissions.
 *
 * **Allowed Permissions:** `roles:read:global`, `roles:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdRolesByRoleIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdRolesByRoleId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdRolesByRoleIdQueryKey(options),
});
/**
 * Rename a municipality's role or replace its permissions (which needs `permissions:grant`), within the municipality's available set.
 *
 * **Allowed Permissions:** `roles:update:global`, `roles:update:municipality`
 */
export const patchMunicipalitiesByMunicipalityIdRolesByRoleIdMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchMunicipalitiesByMunicipalityIdRolesByRoleId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdUsersQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdUsers", options);
/**
 * List a municipality's users with their role, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `users:read:global`, `users:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdUsersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdUsersQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdUsersInfiniteQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdUsers", options, true);
/**
 * List a municipality's users with their role, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `users:read:global`, `users:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdUsersInfiniteOptions = (options) => {
    const opts = infiniteQueryOptions(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMunicipalitiesByMunicipalityIdUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getMunicipalitiesByMunicipalityIdUsersInfiniteQueryKey(options),
    });
    return opts;
};
/**
 * Change a municipality user's role to another of the municipality's roles, one whose permissions you hold yourself, or deactivate them. You cannot change your own user.
 *
 * **Allowed Permissions:** `users:update:global`, `users:update:municipality`
 */
export const patchMunicipalitiesByMunicipalityIdUsersByUserIdMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchMunicipalitiesByMunicipalityIdUsersByUserId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getMunicipalitiesByMunicipalityIdInvitesQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdInvites", options);
/**
 * List a municipality's invites with their status, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `invites:read:global`, `invites:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdInvitesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMunicipalitiesByMunicipalityIdInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getMunicipalitiesByMunicipalityIdInvitesQueryKey(options),
});
export const getMunicipalitiesByMunicipalityIdInvitesInfiniteQueryKey = (options) => createQueryKey("getMunicipalitiesByMunicipalityIdInvites", options, true);
/**
 * List a municipality's invites with their status, paged, sorted and filtered.
 *
 * **Allowed Permissions:** `invites:read:global`, `invites:read:municipality`
 */
export const getMunicipalitiesByMunicipalityIdInvitesInfiniteOptions = (options) => {
    const opts = infiniteQueryOptions(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMunicipalitiesByMunicipalityIdInvites({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getMunicipalitiesByMunicipalityIdInvitesInfiniteQueryKey(options),
    });
    return opts;
};
/**
 * Invite a coworker into the municipality with one of its roles. They get an email to set their password, and become a user when they do.
 *
 * **Allowed Permissions:** `invites:create:global`, `invites:create:municipality`
 */
export const postMunicipalitiesByMunicipalityIdInvitesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdInvites({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Email one of the municipality's pending or expired invites again.
 *
 * **Allowed Permissions:** `invites:update:global`, `invites:update:municipality`
 */
export const postMunicipalitiesByMunicipalityIdInvitesByInviteIdResendMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdInvitesByInviteIdResend({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Revoke one of the municipality's pending or expired invites.
 *
 * **Allowed Permissions:** `invites:delete:global`, `invites:delete:municipality`
 */
export const postMunicipalitiesByMunicipalityIdInvitesByInviteIdRevokeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMunicipalitiesByMunicipalityIdInvitesByInviteIdRevoke({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getInvitesQueryKey = (options) => createQueryKey("getInvites", options);
/**
 * List every invite, global and municipality ones, with its status: pending, accepted, expired or revoked. Paged, sorted (newest first by default) and filtered by the query.
 *
 * **Allowed Permissions:** `invites:read:global`
 */
export const getInvitesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getInvitesQueryKey(options),
});
export const getInvitesInfiniteQueryKey = (options) => createQueryKey("getInvites", options, true);
/**
 * List every invite, global and municipality ones, with its status: pending, accepted, expired or revoked. Paged, sorted (newest first by default) and filtered by the query.
 *
 * **Allowed Permissions:** `invites:read:global`
 */
export const getInvitesInfiniteOptions = (options) => {
    const opts = infiniteQueryOptions(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page = typeof pageParam === "object"
                ? pageParam
                : {
                    query: {
                        page: pageParam,
                    },
                };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getInvites({
                ...options,
                ...params,
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getInvitesInfiniteQueryKey(options),
    });
    return opts;
};
/**
 * Invite someone and email them a link to set their password; they become a user when they do. A global invite (`municipalityId: null`) needs a global role, a municipality one the municipality's.
 *
 * **Allowed Permissions:** `invites:create:global`
 */
export const postInvitesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInvites({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Email a pending or expired invite again; its expiry starts over.
 *
 * **Allowed Permissions:** `invites:update:global`
 */
export const postInvitesByInviteIdResendMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInvitesByInviteIdResend({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Revoke a pending or expired invite; links already sent stop working.
 *
 * **Allowed Permissions:** `invites:delete:global`
 */
export const postInvitesByInviteIdRevokeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInvitesByInviteIdRevoke({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Change your own settings. A setting left out stays as it is; one never saved reads as its default.
 */
export const patchUsersMeSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchUsersMeSettings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getCountriesQueryKey = (options) => createQueryKey("getCountries", options);
/**
 * List the countries municipalities can be in, by name, with their settings. Also open to those who read, create or update municipalities, who see a municipality by its country and pick one from it.
 *
 * **Allowed Permissions:** `countries:read:global`, `municipalities:read:global`, `municipalities:create:global`, `municipalities:update:global`
 */
export const getCountriesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCountries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getCountriesQueryKey(options),
});
/**
 * Add a country by its ISO 3166-1 alpha-2 code. `metricSrid` must be a projection in metres that PostGIS knows.
 *
 * **Allowed Permissions:** `countries:create:global`
 */
export const postCountriesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCountries({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a country. Refused while any municipality is in it.
 *
 * **Allowed Permissions:** `countries:delete:global`
 */
export const deleteCountriesByCountryCodeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCountriesByCountryCode({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getCountriesByCountryCodeQueryKey = (options) => createQueryKey("getCountriesByCountryCode", options);
/**
 * Get a country and its settings.
 *
 * **Allowed Permissions:** `countries:read:global`
 */
export const getCountriesByCountryCodeOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCountriesByCountryCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getCountriesByCountryCodeQueryKey(options),
});
/**
 * Replace a country's settings. Every municipality in it reads them on its next import.
 *
 * **Allowed Permissions:** `countries:update:global`
 */
export const putCountriesByCountryCodeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCountriesByCountryCode({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const getCountriesByCountryCodeDataSourcesQueryKey = (options) => createQueryKey("getCountriesByCountryCodeDataSources", options);
/**
 * Get the adapters a new municipality in this country starts with, by kind and rank. The built-in adapters are not listed because they cannot be switched off.
 *
 * **Allowed Permissions:** `countries:read:global`
 */
export const getCountriesByCountryCodeDataSourcesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCountriesByCountryCodeDataSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
        });
        return data;
    },
    queryKey: getCountriesByCountryCodeDataSourcesQueryKey(options),
});
/**
 * Replace a country's default adapters for one kind of data. The list is complete for that kind; the other kinds are left alone. Every row must name the kind in the path. Only municipalities created afterwards start with the new defaults.
 *
 * **Allowed Permissions:** `countries:update:global`
 */
export const putCountriesByCountryCodeDataSourcesByKindMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCountriesByCountryCodeDataSourcesByKind({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
